/* =========================================================================
   yb-polish.js
   Tiny runtime helpers for visual polish that need real DOM measurements.
   ========================================================================= */

(function() {
  'use strict';

  // ---- Sticky header offset --------------------------------------------------
  // The collection filter sidebar sticks below the header. The header is built
  // from multiple rows (logo row + nav row + Qkify menu) and the Pipeline
  // --header-height var ends up wrong on this custom theme. Measure directly.

  function getStickyHeaderHeight() {
    var total = 0;
    document.querySelectorAll(
      '.header-logo-row, .header-nav-row, [data-header-sticky="sticky"]'
    ).forEach(function(el) {
      // Skip hidden elements (custom header on mobile, Pipeline header on desktop)
      if (el.offsetParent === null && el.tagName !== 'BODY') return;
      total += el.offsetHeight;
    });
    return total;
  }

  function updateStickyOffset() {
    var h = getStickyHeaderHeight();
    if (h > 0) {
      document.documentElement.style.setProperty('--yb-sticky-header-h', h + 'px');
    }
  }

  updateStickyOffset();
  window.addEventListener('load', updateStickyOffset);
  window.addEventListener('resize', updateStickyOffset);

  // Re-measure during scroll because the sticky header can change height
  // (e.g., announcement bar scrolls away).
  var rafPending = false;
  window.addEventListener('scroll', function() {
    if (rafPending) return;
    rafPending = true;
    requestAnimationFrame(function() {
      rafPending = false;
      updateStickyOffset();
    });
  }, { passive: true });

  // ---- Recent searches ------------------------------------------------------
  // Persist the last 5 search terms in localStorage and surface them under the
  // search input when it's focused with no query.

  var STORAGE_KEY = 'yb-recent-searches';
  var MAX_RECENTS = 5;

  function readRecents() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var arr = JSON.parse(raw);
      return Array.isArray(arr) ? arr : [];
    } catch (e) { return []; }
  }

  function writeRecents(arr) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(arr.slice(0, MAX_RECENTS))); }
    catch (e) {}
  }

  function pushRecent(term) {
    term = (term || '').trim();
    if (!term) return;
    var arr = readRecents().filter(function(t) {
      return t.toLowerCase() !== term.toLowerCase();
    });
    arr.unshift(term);
    writeRecents(arr);
  }

  function buildRecentsPanel(input) {
    var existing = document.querySelector('.yb-search-recents[data-for-input="' + input.dataset.predictiveSearchInput + '"]');
    if (existing) return existing;

    var panel = document.createElement('div');
    panel.className = 'yb-search-recents';
    panel.setAttribute('data-for-input', input.dataset.predictiveSearchInput || '');
    panel.hidden = true;

    // Render into the form's wrapper so it sits below the input
    var form = input.closest('form');
    if (!form) return null;
    form.appendChild(panel);
    return panel;
  }

  function renderRecents(panel) {
    var recents = readRecents();
    if (recents.length === 0) {
      panel.hidden = true;
      return;
    }
    var listItems = recents.map(function(term) {
      var safe = String(term)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;')
        .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
      return '<li><button type="button" class="yb-search-recents__chip" data-recent="' + safe + '">' +
        '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true">' +
        '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 3"/></svg>' +
        '<span>' + safe + '</span></button></li>';
    }).join('');
    panel.innerHTML =
      '<p class="yb-search-recents__title">Recent searches' +
        '<button type="button" class="yb-search-recents__clear" aria-label="Clear recent searches">Clear</button>' +
      '</p>' +
      '<ul class="yb-search-recents__list">' + listItems + '</ul>';
    panel.hidden = false;
  }

  function initSearchRecents() {
    var inputs = document.querySelectorAll('[data-predictive-search-input]');
    if (inputs.length === 0) return;

    inputs.forEach(function(input) {
      var panel = buildRecentsPanel(input);
      if (!panel) return;
      var form = input.closest('form');

      function maybeShow() {
        if (input.value.trim() === '' && document.activeElement === input) {
          renderRecents(panel);
        } else {
          panel.hidden = true;
        }
      }

      input.addEventListener('focus', maybeShow);
      input.addEventListener('input', maybeShow);
      input.addEventListener('blur', function() {
        // Delay so click events on chips fire first
        setTimeout(function() { panel.hidden = true; }, 180);
      });

      panel.addEventListener('mousedown', function(e) {
        var chip = e.target.closest('[data-recent]');
        if (chip) {
          e.preventDefault();
          input.value = chip.getAttribute('data-recent');
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.focus();
          return;
        }
        if (e.target.closest('.yb-search-recents__clear')) {
          e.preventDefault();
          writeRecents([]);
          panel.hidden = true;
        }
      });

      if (form) {
        form.addEventListener('submit', function() {
          pushRecent(input.value);
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearchRecents);
  } else {
    initSearchRecents();
  }
})();
